export default __webpack_public_path__ + "static/media/MISTRZ_ARENY.6536f97d.png";